import { BigFloat } from '@1inch-community/core/math';
import { distinctUntilChanged, map, shareReplay, startWith, Subject } from 'rxjs';
import { isTokensEqual } from '../tokens';
export class TokenContext {
    constructor() {
        this.lastSnapshot = { token: null, amount: null };
        this.signalChange$ = new Subject();
    }
    setToken(token) {
        const { token: tokenFromSnap } = this.lastSnapshot;
        if (tokenFromSnap && token && isTokensEqual(tokenFromSnap, token)) {
            return;
        }
        this.lastSnapshot = { ...this.lastSnapshot, token, amount: BigFloat.zero() };
        this.signalChange$.next();
    }
    setAmount(amount) {
        const { amount: amountFromSnap } = this.lastSnapshot;
        if (amountFromSnap?.equals(amount)) {
            return;
        }
        this.lastSnapshot = { ...this.lastSnapshot, amount };
        this.signalChange$.next();
    }
    getSnapshot() {
        return this.lastSnapshot;
    }
    streamSnapshot() {
        return this.signalChange$.pipe(map(() => this.lastSnapshot), startWith(this.lastSnapshot), distinctUntilChanged(tokenSnapshotEquals), shareReplay({ bufferSize: 1, refCount: true }));
    }
}
function tokenSnapshotEquals(s1, s2) {
    const { token: token1, amount: amount1 } = s1;
    const { token: token2, amount: amount2 } = s2;
    if (token1 === null || token2 === null || amount1 === null || amount2 === null) {
        return false;
    }
    return amount1.equals(amount2) && isTokensEqual(token1, token2);
}
//# sourceMappingURL=token-context.js.map